export const numberOfEmployeesOptions = [
  { label: '1', value: '1' },
  { label: '2-5', value: '2-5' },
  { label: '6-10', value: '6-10' },
  { label: '11-25', value: '11-25' },
  { label: '25+', value: '25+' },
  { label: 'I’m not sure', value: 'I’m not sure' },
];

export const monthlyRevenueOptions = [
  { label: '$0 (Pre-revenue)', value: 'Pre-revenue' },
  { label: '$1-$1,000', value: '$1-$1,000' },
  { label: '$1,000-$10,000', value: '$1,000-$10,000' },
  { label: '$10,000-$100,000', value: '$10,000-$100,000' },
  { label: 'More than $100,000', value: 'More than $100,000' },
  { label: 'I’m not sure', value: 'I’m not sure' },
];

const currentYear = new Date().getFullYear();
export const lastYearTaxesFiledOptions = [
  { label: `Tax year ${currentYear - 1}`, value: `${currentYear - 1}` },
  { label: `Tax year ${currentYear - 2}`, value: `${currentYear - 2}` },
  { label: `Tax year ${currentYear - 3} or prior`, value: `${currentYear - 3} or prior` },
  { label: 'My business is new', value: 'new business' },
  { label: 'I’m not sure', value: 'I’m not sure' },
];
